import cn from "classnames"
import React from "react"
import { FilterCheckbox, useSelector } from "swiipe.portal.shared"
import { translationActions, translationSelectors } from "../../../store/reducers/translationSlice"
import useReduxDispatch from "../../../store/useReduxDispatch"
import "./TranslationSelection.scss"

interface ITranslationSelectionProps {
    group: string
    language?: string
    levels?: string[]
    className?: string
}

const TranslationSelection = ({ group, language, levels, className }: ITranslationSelectionProps) => {
    const dispatch = useReduxDispatch()
    const selections = useSelector(translationSelectors.selections)
    const items = useSelector(translationSelectors.items) ?? []
    const levelsString = levels ? levels.join(".") : ""
    const relevantItemIds = items
        .filter(
            (i) =>
                i.group === group &&
                (!levels ||
                    i.levelsString === levelsString ||
                    (i.levelsString.startsWith(levelsString) && i.levelsString[levelsString.length] === "."))
        )
        .map((ri) => ri.id)

    // At least matching some languages
    const relevantSelections = selections.filter(
        (s) => relevantItemIds.includes(s.itemId) && (!language || !s.languages || s.languages.includes(language))
    )
    const isFullSelection =
        relevantSelections.length === relevantItemIds.length &&
        (!language
            ? !relevantSelections.some((rs) => !!rs.languages)
            : !relevantSelections.some((rs) => rs.languages && !rs.languages.includes(language)))
    const isPartlySelection = !isFullSelection && relevantSelections.length > 0
    return (
        <div className={cn("translation-selection", className)}>
            <div className="translation-selection__inner-container">
                {isPartlySelection && <span>(</span>}
                <FilterCheckbox
                    label=""
                    showFilters={false}
                    isChecked={isFullSelection || isPartlySelection}
                    onChange={(checked) => {
                        if (checked === (isFullSelection || isPartlySelection)) {
                            return
                        }
                        if (levels) {
                            const keys = relevantItemIds.map((itemId) => items.find((i) => i.id === itemId)!.key)
                            dispatch(
                                translationActions.changeSelection({
                                    group: group,
                                    keys: keys,
                                    language: language,
                                    isSelected: checked,
                                })
                            )
                        } else {
                            dispatch(
                                translationActions.changeSelection({
                                    group: group,
                                    keys: undefined,
                                    language: language,
                                    isSelected: checked,
                                })
                            )
                        }
                    }}
                />{" "}
                {isPartlySelection && <span>)</span>}
            </div>
        </div>
    )
}

export default React.memo(TranslationSelection)
